export default __webpack_public_path__ + "static/media/logo-blanco.1fd27592.png";